// Prevent multiple error toasts from firing for the same failed request.
let lastErrorShownAt = 0;
function showErrorOnce(message) {
    const now = Date.now();
    if (now - lastErrorShownAt < 2000) return;
    lastErrorShownAt = now;
    Vue.toasted.error(message);
}

window.alert = (function () {
    // Set nativeAlert
    let nativeAlert = window.alert;

    // See what to return
    return function (message) {

        // Check if it's a datatable warning
        if (message.indexOf('DataTables warning') === 0) {
            // Use toast and console instead of alert
            showErrorOnce('Er is iets misgegaan bij het laden van de tabel. Ververs de pagina.');
            console.error(message);
        } else {
            // No datatable use nativeAlert
            nativeAlert(message);
        }
    };
})();

// Fetch ajax errors
$(document).ajaxError((event, request, settings, thrownError) => {

    // Check if status is 401
    if (request.status === 401) {

        // Reload top window so middleware takes over authentication
        window.top.location.reload();
        return;
    }

    if (request.status === 419) {
        window.Swal && Swal.fire({
            icon: 'warning',
            title: 'Sessie verlopen',
            text: 'Je sessie is verlopen. De pagina wordt opnieuw geladen.',
            confirmButtonText: 'Herlaad pagina',
            confirmButtonColor: '#4f46e5',
            allowOutsideClick: false,
        }).then(() => window.location.reload());
        return;
    }

    if (request.status === 0 && thrownError !== 'abort') {
        // Network error (no response at all — connection lost, timeout, etc.)
        showErrorOnce('Geen verbinding met de server. Controleer je internetverbinding.');
        return;
    }

    if (request.status >= 500) {
        showErrorOnce('Er ging iets mis. Probeer het later opnieuw.');
    }
});
